import React, { PropTypes } from 'react'
import { rhythm } from '../../utils/typography'
import './style.less'
import LeadForm from '../LeadForm'

function Footer(props) {
  const { openModal } = props

  return (
    <div className="footer" style={{
        marginTop: rhythm(3),
        paddingTop: rhythm(2),
        paddingBottom: rhythm(2)
    }}>
      <div className="container page">
        <div className="row between-xs">
          <div className="col-xs-12 col-sm center-xs start-sm last-xs first-sm">
            <p>Acoustic Cleaning Systems, Inc.</p>
            <p>P &ndash; 256-820-8427</p>
            <p>F &ndash; 256-820-6570</p>
            <p>PO Box 609</p>
            <p>Alexandria, AL 36250</p>
          </div>
          <div className="col-xs-12 col-sm links center-xs start-sm">
            <a href="/learn/"><h4>What’s Acoustic Cleaning?</h4></a>
            <a href="/applications/"><h4>Applications</h4></a>
            <a href="/products/"><h4>Products</h4></a>
            <a href="/projects/"><h4>Projects</h4></a>
          </div>
          <div className="col-xs-12 col-sm links center-xs start-sm">
            <a href="/service/"><h4>Parts & Service</h4></a>
            <a href="/technical/"><h4>Technical Docs</h4></a>
            <a href="/about/"><h4>About ACS</h4></a>
            <a href="/"><h4>Home</h4></a>
          </div>
          <div className="col-xs-12 col-sm cta last-xs">
            <LeadForm />
          </div>
        </div>
      </div>
    </div>
  )
}

Footer.propTypes = {

}

Footer.defaultProps = {

}

export default Footer



// WEBPACK FOOTER //
// ../components/Footer/index.js